import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';

interface Response {
  data: {
    upload_url: string;
    file_url: string;
  };
  status: number;
}

const uploadToken = (): Promise<Response> => {
  return axios.post('/getUrl');
};

export const useUploadUrl = (uploadKey: string) => {
  return useQuery({
    queryKey: ['uploadUrl', uploadKey],
    queryFn: uploadToken,
    select: (data) => {
      return data.data;
    },
  });
};
